import { CloseioIntegrationStore } from 'src/crm/closeio/state'
import { HubspotIntegrationStore } from 'src/crm/hubspot/state'
import { SalesforceIntegrationStore } from 'src/crm/salesforce/state'

import { CrmProvider } from '../crm/types'
import { FontSizeType } from '../tailwind'

export function nameForCrm(crmProvider: CrmProvider): string {
  switch (crmProvider) {
    case 'hubspot':
      return 'HubSpot'
    case 'salesforce':
      return 'Salesforce'
    case 'closeio':
      return 'Close'
    default:
      crmProvider
  }
}

export function storeForCrm(crm: 'salesforce' | 'hubspot' | 'closeio') {
  switch (crm) {
    case 'salesforce':
      return SalesforceIntegrationStore
    case 'hubspot':
      return HubspotIntegrationStore
    case 'closeio':
      return CloseioIntegrationStore
  }
}

export function textColorForCrmProvider(crmProvider: CrmProvider): string {
  return {
    closeio: '#2F577E',
    hubspot: '#FF7A59',
    salesforce: '#17A0DB',
  }[crmProvider]
}

export function iconSizeForCrmProvider(crmProvider: CrmProvider): FontSizeType {
  return {
    closeio: '2xl',
    hubspot: 'xl',
    salesforce: '5xl',
  }[crmProvider] as FontSizeType
}
